import { Navigate, Link, useParams } from "react-router-dom";
import { useUpcomingExams } from "@/hooks/useExams";
import LoadingState from "../components/LoadingState";
import ErrorState from "../components/ErrorState";
export default function DenemePage() {
  const { id } = useParams();
  const { data, loading, error, reload } = useUpcomingExams();
  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} onRetry={reload} />;
  const exam = data?.find(item => item.id === id);
  if (!exam) return <div className="p-8"><h1 className="text-xl font-bold">Deneme bulunamadı</h1><Link className="underline" to="/ogrenci/deneme-sinavlari">Denemelere dön</Link></div>;
  return <Navigate replace to={`/ogrenci/soru-bankasi/test?lesson=${encodeURIComponent(exam.subject)}&count=25&duration=${parseInt(exam.duration,10)||45}`} />;
}
